import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';

const LazyWhoIsOnCallWidget = lazyForPaint(() =>
	import(/* webpackChunkName: "async-eoc-who-is-on-call-widget" */ './main').then(
		({ WhoIsOnCallWidget }) => WhoIsOnCallWidget,
	),
);

export const AsyncWhoIsOnCallWidget = () => (
	<Placeholder name="async-eoc-who-is-on-call-widget" fallback={null}>
		<LazyWhoIsOnCallWidget />
	</Placeholder>
);
